import { isDevMode } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from './environments/environment';

// Ensure to call this before requiring any other modules!
Sentry.init({
  ...environment.sentryOptions,
  integrations: [
    Sentry.httpClientIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.contextLinesIntegration(),
    Sentry.launchDarklyIntegration(),
  ],
  /**
   * We recommend adjusting this value in production, or using
   * tracesSampler for finer control
   */
  tracesSampleRate: environment.sentryOptions.environment === 'local' ? 0 : 0.2,
  /**
   * Set `tracePropagationTargets` to control for which URLs
   * trace propagation should be enabled
   */
  tracePropagationTargets: [
    'localhost',
    new RegExp(`^${environment.appApiUrl}/`),
    new RegExp(`^wss://canadacentral.stt.speech.microsoft.com/`),
  ],
  sendDefaultPii: false,
  beforeSend: (event) => {
    if (isDevMode()) {
      console.warn({
        message: 'Logging Sentry event instead of sending to Sentry',
        event,
      });
      return null;
    }
    return event;
  },
});
